import React, { useCallback, useEffect, useRef, useState } from "react";

import {
  InfoList,
  AcademicSection,
  ButtonContainer,
  Content,
  CustomButton,
  InputContainer,
  InputRow,
  MainSection,
  PersonalInformationDiv,
  ProfessionalSection,
  WelcomeDiv,
  WelcomeText,
  WelcomeTitle,
  SkillsSection,
  CheckboxesDiv,
  EditIconContainer,
  CourseDiv,
  InputContainerCourse,
  InputContainerYear,
  AdminSection,
} from "./styled";

import { useSearchParams } from "react-router-dom";

import { Form, WarningInputMessage } from "../../styles/GlobalStyles";
import { CreateNewAcademicModal } from "../../components/AcademicModal";

import EditIcon from "@mui/icons-material/Edit";

import api from "../../api/axios";

import { AcademicInfoCard } from "../../components/AcademicInfoCard";
import { AddInfoButton } from "../../components/AddInfoButton";
import { CreateNewExperienceModal } from "../../components/ExperienceModal";
import { ExperienceCard } from "../../components/ExperienceCard";
import { Checkboxes } from "../../components/Checkboxes";
import ReactInputMask from "react-input-mask";
import { Header } from "../../components/Header";
import { CreateNewEducationModal } from "../../components/EducationModal";
import { formatAcademicLevel } from "../../utils/formatAcademicLevel";
import { MenuItem, Select } from "@mui/material";
import { BRAZILIAN_STATES } from "../../constants/brazilianStates";
import { useNavigate, useParams } from "react-router-dom";
import WhatsappButton from "../../components/WhatsappButton";
import { toast } from "react-toastify";
import { validarCPF } from "../../utils/validarCPF";
import { AppliedOportunitiesModal } from "../../components/AppliedOportunititesModal";
import { CreateNewOcurrencesModal } from "../../components/OcurrencesModal";
import { ApplyProfessionalModal } from "../../components/ApplyProfessionalModal";
import FullScreenLoader from "../../components/FullScreenLoader";
import dayjs from "dayjs";
import { ProfessionalAllDocsModal } from "../../components/ProfessionalAllDocsModal";
// import { TermsModal } from "../../components/TermsModal";

const Perfil = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [userAgreeData, setUserAgreeData] = useState(null);

  const [isLoading, setIsLoading] = useState(true);

  const [professionalEmail, setProfessionalEmail] = useState("");

  const [ocurrencesModalOpen, setOcurrencesModalOpen] = useState(false);
  const [allDocsModalOpen, setAllDocsModalOpen] = useState(false);

  const [userId, setUserId] = useState("");
  const [admin, setAdmin] = useState(false);

  const [userData, setUserData] = useState({});
  const [newUserData, setNewUserData] = useState({});

  const [unlockDistrict, setUnlockDistrict] = useState(false);
  const [unlockStreet, setUnlockStreet] = useState(false);

  const [skills, setSkills] = useState([]);

  const [newApplicationModalOpen, setNewApplicationModalOpen] = useState(false);

  const [createEducationModalOpen, setCreateEducationModalOpen] =
    useState(false);
  const [createAcademicModalOpen, setCreateAcademicModalOpen] = useState(false);
  const [academicModalType, setAcademicModalType] = useState("");
  const [experienceModalType, setExperienceModalType] = useState("");
  const [createExperienceModalOpen, setCreateExperienceModalOpen] =
    useState(false);
  const [applicationsModalOpen, setApplicationsModalOpen] = useState(false);

  // const [termsModalOpen, setTermsModalOpen] = useState(true);

  const { paramId } = useParams();
  const fileInputRef = useRef();

  const savedState = JSON.parse(
    sessionStorage.getItem("adminPageState") || "{}",
  );

  const professionalIds = savedState.professionalIds || [];

  const currentIndex = professionalIds.indexOf(paramId);

  const previousId =
    currentIndex > 0 ? professionalIds[currentIndex - 1] : null;

  const nextId =
    currentIndex !== -1 && currentIndex < professionalIds.length - 1
      ? professionalIds[currentIndex + 1]
      : null;

  const getUser = async () => {
    let res;
    const me = await api.get("/user/me");

    if (paramId) {
      res = await api.get(`/professional/search-user/${paramId}`);
      const email = searchParams.get("email");
      setProfessionalEmail(email);
      setUserId(res.data.user);
    } else {
      setUserId(me.data._id);
    }
    setAdmin(me.data.role === "admin");
  };

  const getUserAgree = async () => {
    try {
      const { data } = await api.get("/user_agree/get-agree/" + paramId);
      setUserAgreeData(data);
    } catch (err) {
      toast.error("Ocorreu um erro");
      console.error(err);
    }
  };

  const handleEditEducationcClick = () => {
    setCreateEducationModalOpen(true);
  };

  const handleCloseEducation = async () => {
    getData();
    setCreateEducationModalOpen(false);
  };

  const handleAddAcademicClick = () => {
    setAcademicModalType("create");
    setCreateAcademicModalOpen(true);
  };

  const handleCloseAcademic = async () => {
    getData();
    setCreateAcademicModalOpen(false);
  };

  const handleAddExperienceClick = () => {
    setExperienceModalType("create");
    setCreateExperienceModalOpen(true);
  };

  const handleCloseExperience = async () => {
    getData();
    setCreateExperienceModalOpen(false);
  };

  // const handleCloseTermsModal = () => {
  //   setTermsModalOpen(false);
  // };

  const navigateOportunities = (e) => {
    e.preventDefault();

    window.location.href = "https://ticoopbrasil.coop.br/oportunidades-ti/";
  };

  const updateData = async (e) => {
    e.preventDefault();

    if (!validarCPF(newUserData.cpf) && !admin) {
      toast.error("CPF inválido");
      return;
    }

    try {
      const { data: availableCpf } = await api.post(
        "/professional/verify-cpf",
        {
          cpf: newUserData.cpf,
        },
      );

      if (!availableCpf.status && newUserData.cpf !== userData.cpf) {
        toast.error("Esse CPF já está cadastrado no sistema");
        return;
      }
    } catch (err) {
      console.log(err);
      toast.error("Ocorreu um erro");
    }

    if (
      (!newUserData.address ||
        !newUserData.address.cep ||
        newUserData.address.cep.replaceAll("_", "").length < 9) &&
      !admin
    ) {
      toast.error("CEP inválido");
      return;
    }

    let formattedData = { ...newUserData };

    if (newUserData?.address?.cep) {
      formattedData = {
        ...formattedData,
        address: {
          ...newUserData.address,
          street: newUserData.address.number
            ? `${newUserData.address.street}, ${newUserData.address.number}`
            : newUserData.address.street,
        },
      };

      if (formattedData.address.number) delete formattedData.address.number;
    }

    try {
      const res = await api.put(
        `/professional/update/${userData._id}`,
        formattedData,
      );

      if (res.status === 200) toast.success("Dados atualizados com sucesso!");
      getData();
    } catch (error) {
      toast.error(error);
    }
  };

  const getSkills = async () => {
    try {
      const res = await api.get("/skill/list");
      setSkills(res.data);
    } catch (error) {
      toast.error(error);
    }
  };

  const formatAddressNumber = (data) => {
    if (data && data?.address) {
      const itens = data?.address?.street.split(", ");

      const newData = {
        ...data,
        address: {
          ...data?.address,
          street: itens[0],
          number: itens[1],
        },
      };

      return newData;
    }

    return data;
  };

  const getData = useCallback(async () => {
    try {
      const res = await api.get(`/professional/search-user/${userId}`);
      setUserData(formatAddressNumber(res.data));
      setNewUserData(formatAddressNumber(res.data));
      setIsLoading(false);
    } catch (error) {
      toast.error(error);
    }
  }, [userId]);

  const handleCurriculumClick = async (e) => {
    e.preventDefault();
    if (userData.curriculum) {
      const res = await api.post("/professional/get-signed-url", {
        url: userData.curriculum,
      });
      if (res.status === 200) {
        window.open(res.data.signedUrl, "_blank");
      } else {
        toast.error("Ocorreu um erro");
      }
    } else {
      fileInputRef.current.click();
    }
  };

  const handleCurriculumDelete = async (e) => {
    e.preventDefault();
    try {
      await api.delete(`/professional/curriculum/${userData._id}`);

      toast.success("Currículo removido com sucesso!");
      getData();
    } catch (error) {
      toast.error("Erro ao excluir currículo");
    }
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("curriculum", file);

    try {
      await api.put(`/professional/curriculum/${userData._id}`, formData);

      getData();
      toast.success("Currículo enviado com sucesso!");
    } catch (error) {
      console.error("Erro ao enviar currículo:", error);
      toast.error("Erro ao enviar currículo");
    }
  };

  useEffect(() => {
    getUser();
    getSkills();
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getData]);

  useEffect(() => {
    getUser();
    getSkills();
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paramId]);

  useEffect(() => {
    if (admin && paramId) {
      getUserAgree();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [admin, paramId]);

  return (
    <Content>
      <FullScreenLoader fadeOut={!isLoading} />
      <WhatsappButton />
      <Header />
      {admin && (
        <>
          <AdminSection>
            <h1>Painel Admin</h1>
            <div>
              <CustomButton onClick={() => setNewApplicationModalOpen(true)}>
                Vincular Oportunidade
              </CustomButton>
              <CustomButton onClick={() => setApplicationsModalOpen(true)}>
                Ver Oportunidades
              </CustomButton>
              <CustomButton onClick={() => setOcurrencesModalOpen(true)}>
                Ver Ocorrências
              </CustomButton>
              <CustomButton onClick={() => setAllDocsModalOpen(true)}>
                Ver Documentos
              </CustomButton>
              <CustomButton
                onClick={() => {
                  try {
                    const to = encodeURIComponent(professionalEmail);
                    const subject = encodeURIComponent("Assunto");
                    const body = encodeURIComponent("Mensagem");

                    const outlookWebUrl = `https://outlook.office.com/mail/deeplink/compose?to=${to}&subject=${subject}&body=${body}`;

                    window.open(outlookWebUrl, "_blank");
                  } catch (err) {
                    toast.error("Erro ao enviar email.");
                  }
                }}
              >
                Enviar E-mail
              </CustomButton>
              <CustomButton
                onClick={() => {
                  try {
                    const number = userData.phone.replace(/\D/g, "");
                    const whatsappLink = `https://wa.me/55${number}`;
                    window.open(whatsappLink, "_blank");
                  } catch (err) {
                    toast.error("Erro ao enviar mensagem.");
                  }
                }}
              >
                Enviar Mensagem
              </CustomButton>
            </div>
            <span style={{ marginTop: "10px", color: "white" }}>
              {userAgreeData
                ? `Usuário aceitou a versão ${userAgreeData.file.version || "ERRO"} dos Termos no dia ${dayjs(userAgreeData.agreedAt).format("DD/MM/YYYY") || "ERRO"}.`
                : "Esse usuário ainda não aceitou os Termos."}
            </span>
          </AdminSection>
          {paramId && (
            <>
              <div
                style={{
                  gap: "5px",
                  margin: "20px 0",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <CustomButton
                    onClick={() => {
                      setIsLoading(true);
                      navigate(`/editar-profissional/${previousId}`);
                    }}
                    disabled={!previousId}
                  >
                    Anterior
                  </CustomButton>
                </div>
                <CustomButton
                  alt={true}
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("/");
                  }}
                >
                  Voltar
                </CustomButton>
                <div>
                  <CustomButton
                    onClick={() => {
                      setIsLoading(true);
                      navigate(`/editar-profissional/${nextId}`);
                    }}
                    disabled={!nextId}
                  >
                    Próximo
                  </CustomButton>
                </div>
              </div>
            </>
          )}
        </>
      )}

      <MainSection>
        <div
          style={{
            gap: "5px",
            marginBottom: "20px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div>
            <WelcomeTitle>
              {`${paramId ? "Editando profissional" : "Seja bem-vindo,"} ${
                userData.name
              }`}
              !
            </WelcomeTitle>
            <WelcomeText>{`${
              paramId ? "" : "Gerencie suas informações aqui"
            }`}</WelcomeText>
          </div>
          {paramId ? (
            <div>
              <CustomButton onClick={() => setApplicationsModalOpen(true)}>
                Ver Candidaturas
              </CustomButton>
            </div>
          ) : (
            <div>
              <CustomButton onClick={() => setApplicationsModalOpen(true)}>
                Minhas Candidaturas
              </CustomButton>
              <CustomButton onClick={navigateOportunities}>
                Ver Oportunidades
              </CustomButton>
            </div>
          )}
        </div>
        <PersonalInformationDiv>
          <Form>
            <InputRow>
              <InputContainer>
                {/* Full name */}
                <label for="name">Nome Completo:</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  defaultValue={userData.name}
                  value={newUserData.name}
                  onChange={(e) => {
                    setNewUserData({ ...newUserData, name: e.target.value });
                  }}
                  onBlur={(e) =>
                    !e.target.value
                      ? setNewUserData({ ...newUserData, name: userData.name })
                      : setNewUserData({ ...newUserData, name: e.target.value })
                  }
                />
                {userData.name !== newUserData.name ? (
                  <WarningInputMessage>
                    Atenção! Esse campo será alterado
                  </WarningInputMessage>
                ) : (
                  <></>
                )}
              </InputContainer>
              <InputContainer>
                {/* CPF */}
                <label for="cpf">CPF:</label>
                <ReactInputMask
                  mask={"999.999.999-99"}
                  defaultValue={userData.cpf}
                  value={newUserData.cpf}
                  onChange={(e) => {
                    setNewUserData({ ...newUserData, cpf: e.target.value });
                  }}
                  onBlur={(e) =>
                    !e.target.value
                      ? setNewUserData({
                          ...newUserData,
                          cpf: userData.cpf,
                        })
                      : setNewUserData({
                          ...newUserData,
                          cpf: e.target.value,
                        })
                  }
                >
                  {(inputProps) => (
                    <input {...inputProps} id="cpf" name="cpf" type="text" />
                  )}
                </ReactInputMask>
                {userData.cpf !== newUserData.cpf ? (
                  !validarCPF(newUserData.cpf) ? (
                    <WarningInputMessage>CPF inválido</WarningInputMessage>
                  ) : (
                    <WarningInputMessage>
                      Atenção! Esse campo será alterado
                    </WarningInputMessage>
                  )
                ) : (
                  <></>
                )}
              </InputContainer>
              <InputContainer>
                {/* Phone */}
                <label for="phone">Telefone:</label>
                <ReactInputMask
                  mask={"(99) 99999-9999"}
                  defaultValue={userData.name}
                  value={newUserData.phone}
                  onChange={(e) =>
                    setNewUserData({ ...newUserData, phone: e.target.value })
                  }
                  onBlur={(e) =>
                    !e.target.value
                      ? setNewUserData({
                          ...newUserData,
                          phone: userData.phone,
                        })
                      : setNewUserData({
                          ...newUserData,
                          phone: e.target.value,
                        })
                  }
                >
                  {(inputProps) => (
                    <input
                      {...inputProps}
                      id="phone"
                      name="phone"
                      type="text"
                    />
                  )}
                </ReactInputMask>
                {userData.phone !== newUserData.phone ? (
                  <WarningInputMessage>
                    Atenção! Esse campo será alterado
                  </WarningInputMessage>
                ) : (
                  <></>
                )}
              </InputContainer>
              <InputContainer>
                {/* CEP */}
                <label for="cep">CEP:</label>
                <ReactInputMask
                  mask={"99999-999"}
                  defaultValue={userData.address?.cep || ""}
                  value={newUserData.address?.cep}
                  onChange={(e) => {
                    if (e.target.value) {
                      setNewUserData({
                        ...newUserData,
                        address: {
                          ...newUserData.address,
                          cep: e.target.value,
                        },
                      });
                    } else {
                      setNewUserData({
                        ...newUserData,
                        address: {
                          ...newUserData.address,
                          cep:
                            userData.address && userData.address.cep
                              ? userData.address.cep
                              : "",
                        },
                      });
                    }
                  }}
                  onBlur={async (e) => {
                    const value = e.target.value;

                    if (
                      !value ||
                      e.target.value.replaceAll("_", "").length !== 9
                    ) {
                      setNewUserData({
                        ...newUserData,
                        address: userData.address,
                      });

                      const cepSemHifen = userData?.address?.cep?.replace(
                        "-",
                        "",
                      );

                      try {
                        const response = await api.get(
                          `https://viacep.com.br/ws/${cepSemHifen}/json`,
                        );

                        if (response.data && !response.data.erro) {
                          if (!response.data.bairro) {
                            setUnlockDistrict(true);
                          } else {
                            setUnlockDistrict(false);
                          }
                          if (!response.data.logradouro) {
                            setUnlockStreet(true);
                          } else {
                            setUnlockStreet(false);
                          }
                        }
                      } catch (error) {
                        console.log(error);
                      }
                      return;
                    }

                    const cepSemHifen = value.replace("-", "");

                    if (cepSemHifen.length === 8) {
                      try {
                        const response = await api.get(
                          `https://viacep.com.br/ws/${cepSemHifen}/json`,
                        );

                        if (response.data && !response.data.erro) {
                          if (!response.data.bairro) {
                            setUnlockDistrict(true);
                          } else {
                            setUnlockDistrict(false);
                          }
                          if (!response.data.logradouro) {
                            setUnlockStreet(true);
                          } else {
                            setUnlockStreet(false);
                          }

                          const newData = {
                            ...newUserData,
                            address: {
                              ...newUserData.address,
                              street: response.data.logradouro || "",
                              district: response.data.bairro || "",
                              city: response.data.localidade || "",
                              state: response.data.estado || "",
                              cep: value,
                            },
                          };
                          setNewUserData(newData);
                        } else {
                          setNewUserData({
                            ...newUserData,
                            address: {
                              street: "",
                              district: "",
                              city: "",
                              state: "",
                            },
                          });
                        }
                      } catch (error) {
                        setNewUserData({
                          ...newUserData,
                          address: {
                            street: "",
                            district: "",
                            city: "",
                            state: "",
                          },
                        });
                      }
                    }
                  }}
                >
                  {(inputProps) => (
                    <input {...inputProps} id="cep" name="cep" type="text" />
                  )}
                </ReactInputMask>
                {newUserData.address?.cep &&
                userData.address?.cep !== newUserData.address?.cep ? (
                  <WarningInputMessage>
                    Atenção! Esse campo será alterado
                  </WarningInputMessage>
                ) : (
                  <></>
                )}
              </InputContainer>
              <CourseDiv>
                <InputContainerCourse>
                  {/* Address */}
                  <label for="address">Endereço:</label>
                  <input
                    id="address"
                    name="address"
                    type="text"
                    defaultValue={userData.address?.street || ""}
                    value={newUserData.address?.street}
                    disabled={!unlockStreet}
                    onChange={(e) =>
                      setNewUserData({
                        ...newUserData,
                        address: {
                          ...newUserData.address,
                          street: e.target.value,
                        },
                      })
                    }
                    onBlur={(e) => {
                      const value = e.target.value;

                      setNewUserData({
                        ...newUserData,
                        address: {
                          ...newUserData.address,
                          street: value || userData.address?.street || "",
                        },
                      });
                    }}
                  />
                  {newUserData.address?.street &&
                  userData.address?.street !== newUserData.address?.street ? (
                    <WarningInputMessage>
                      Atenção! Esse campo será alterado
                    </WarningInputMessage>
                  ) : (
                    <></>
                  )}
                </InputContainerCourse>
                <InputContainerYear>
                  <label for="number">Número:</label>
                  <input
                    id="number"
                    name="number"
                    type="text"
                    value={newUserData.address?.number}
                    onChange={(e) =>
                      setNewUserData({
                        ...newUserData,
                        address: {
                          ...newUserData.address,
                          number: e.target.value,
                        },
                      })
                    }
                    onBlur={(e) => {
                      const value = e.target.value;

                      setNewUserData({
                        ...newUserData,
                        address: {
                          ...newUserData.address,
                          number: value || userData.address?.number || "",
                        },
                      });
                    }}
                  />
                  {newUserData.address?.number &&
                  userData.address?.number !== newUserData.address?.number ? (
                    <WarningInputMessage>
                      Atenção! Esse campo será alterado
                    </WarningInputMessage>
                  ) : (
                    <></>
                  )}
                </InputContainerYear>
              </CourseDiv>
              <InputContainer>
                {/* City */}
                <label for="city">Cidade:</label>
                <input
                  id="city"
                  name="city"
                  type="text"
                  defaultValue={userData.address?.city || ""}
                  value={newUserData.address?.city}
                  disabled
                  onChange={(e) =>
                    setNewUserData({
                      ...newUserData,
                      address: {
                        ...newUserData.address,
                        city: e.target.value,
                      },
                    })
                  }
                  onBlur={(e) => {
                    const value = e.target.value;

                    setNewUserData({
                      ...newUserData,
                      address: {
                        ...newUserData.address,
                        city: value || userData.address?.city || "",
                      },
                    });
                  }}
                />
                {newUserData.address?.city &&
                userData.address?.city !== newUserData.address?.city ? (
                  <WarningInputMessage>
                    Atenção! Esse campo será alterado
                  </WarningInputMessage>
                ) : (
                  <></>
                )}
              </InputContainer>
              <InputContainer>
                <label for="state">Estado:</label>
                <Select
                  id="state"
                  name="state"
                  value={newUserData.address?.state || ""}
                  sx={{
                    backgroundColor: "#FFF",
                    height: "50px",
                    textAlign: "start",
                    fontSize: "0.9rem",

                    "&.Mui-disabled": {
                      backgroundColor: "#f2f2f2",
                    },

                    "& .MuiSelect-select.Mui-disabled": {
                      backgroundColor: "#f2f2f2",
                    },
                  }}
                  disabled
                  onChange={(e) =>
                    setNewUserData({
                      ...newUserData,
                      address: {
                        ...newUserData.address,
                        state: e.target.value,
                      },
                    })
                  }
                  onBlur={(e) => {
                    const value = e.target.value;

                    setNewUserData({
                      ...newUserData,
                      address: {
                        ...newUserData.address,
                        state: value || userData.address?.state || "",
                      },
                    });
                  }}
                >
                  {BRAZILIAN_STATES.map((state) => (
                    <MenuItem key={state} value={state}>
                      {state}
                    </MenuItem>
                  ))}
                </Select>

                {newUserData.address?.state &&
                userData.address?.state !== newUserData.address?.state ? (
                  <WarningInputMessage>
                    Atenção! Esse campo será alterado
                  </WarningInputMessage>
                ) : (
                  <></>
                )}
              </InputContainer>
              <InputContainer>
                {/* District */}
                <label for="district">Bairro:</label>
                <input
                  id="district"
                  name="district"
                  type="text"
                  defaultValue={userData.address?.district || ""}
                  value={newUserData.address?.district}
                  disabled={!unlockDistrict}
                  onChange={(e) =>
                    setNewUserData({
                      ...newUserData,
                      address: {
                        ...newUserData.address,
                        district: e.target.value,
                      },
                    })
                  }
                  onBlur={(e) => {
                    const value = e.target.value;

                    setNewUserData({
                      ...newUserData,
                      address: {
                        ...newUserData.address,
                        district: value || userData.address?.district || "",
                      },
                    });
                  }}
                />
                {newUserData.address?.district &&
                userData.address?.district !== newUserData.address?.district ? (
                  <WarningInputMessage>
                    Atenção! Esse campo será alterado
                  </WarningInputMessage>
                ) : (
                  <></>
                )}
              </InputContainer>
              <InputContainer>
                {/* Additional Info */}
                <label for="additional">Complemento:</label>
                <input
                  id="additional"
                  name="additional"
                  type="text"
                  value={newUserData.address?.additional}
                  onChange={(e) =>
                    setNewUserData({
                      ...newUserData,
                      address: {
                        ...newUserData.address,
                        additional: e.target.value,
                      },
                    })
                  }
                  onBlur={(e) => {
                    const value = e.target.value;

                    setNewUserData({
                      ...newUserData,
                      address: {
                        ...newUserData.address,
                        additional: value || "",
                      },
                    });
                  }}
                />
                {newUserData.address?.additional &&
                userData.address?.additional !==
                  newUserData.address?.additional ? (
                  <WarningInputMessage>
                    Atenção! Esse campo será alterado
                  </WarningInputMessage>
                ) : (
                  <></>
                )}
              </InputContainer>
            </InputRow>
            <ButtonContainer>
              <div>
                <>
                  <CustomButton onClick={handleCurriculumClick}>
                    {!userData.curriculum
                      ? "Adicionar currículo"
                      : "Ver currículo"}
                  </CustomButton>
                  <input
                    type="file"
                    accept=".pdf,.doc,.docx"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                  />
                </>
                {userData.curriculum && (
                  <CustomButton onClick={handleCurriculumDelete}>
                    Remover currículo
                  </CustomButton>
                )}
              </div>
              <div>
                <CustomButton type="submit" onClick={updateData}>
                  Salvar Alterações
                </CustomButton>
              </div>
            </ButtonContainer>
          </Form>
        </PersonalInformationDiv>
      </MainSection>
      <SkillsSection>
        <WelcomeDiv>
          <WelcomeTitle>Tecnologias que domina</WelcomeTitle>
        </WelcomeDiv>
        <CheckboxesDiv>
          <Checkboxes
            options={skills}
            data={newUserData}
            setData={setNewUserData}
          />
          <ButtonContainer>
            <CustomButton type="submit" onClick={updateData}>
              Salvar Alterações
            </CustomButton>
          </ButtonContainer>
        </CheckboxesDiv>
      </SkillsSection>
      <AcademicSection>
        <WelcomeDiv>
          <WelcomeTitle>Informações Acadêmicas</WelcomeTitle>
          <WelcomeText>
            Sua formação:{" "}
            {userData.academicLevel?.educationLevel &&
            !userData.academicLevel?.educationLevel.includes("Ensino Médio")
              ? formatAcademicLevel(userData.academicLevel) || ""
              : userData.academicLevel?.educationLevel || ""}
            <EditIconContainer>
              <EditIcon onClick={handleEditEducationcClick} />
            </EditIconContainer>
          </WelcomeText>
        </WelcomeDiv>
        <InfoList>
          {Array.isArray(userData.courses) && userData.courses.length > 0 ? (
            <>
              {[...userData.courses]
                .sort((a, b) => a.year - b.year)
                .map((course) => (
                  <AcademicInfoCard
                    key={course._id || course.id}
                    course={course}
                    userData={userData}
                    getData={getData}
                  />
                ))}
            </>
          ) : (
            <></>
          )}
          <AddInfoButton
            text={"Adicionar formação"}
            handleAddClick={handleAddAcademicClick}
          />
        </InfoList>
      </AcademicSection>
      <ProfessionalSection>
        <WelcomeDiv>
          <WelcomeTitle>Experiências Profissionais</WelcomeTitle>
        </WelcomeDiv>
        <InfoList>
          {Array.isArray(userData.experiences) &&
          userData.experiences.length > 0 ? (
            <>
              {userData.experiences.map((experience) => (
                <ExperienceCard
                  experience={experience}
                  userData={userData}
                  getData={getData}
                />
              ))}
            </>
          ) : (
            <></>
          )}
          <AddInfoButton
            text={"Adicionar experiência"}
            handleAddClick={handleAddExperienceClick}
          />
        </InfoList>
      </ProfessionalSection>
      <CreateNewEducationModal
        open={createEducationModalOpen}
        onClose={handleCloseEducation}
        educationData={userData?.academicLevel}
        userId={userData?._id}
      />
      <CreateNewAcademicModal
        open={createAcademicModalOpen}
        onClose={handleCloseAcademic}
        user={userData}
        type={academicModalType}
      />
      <CreateNewExperienceModal
        open={createExperienceModalOpen}
        onClose={handleCloseExperience}
        user={userData}
        type={experienceModalType}
      />
      <AppliedOportunitiesModal
        open={applicationsModalOpen}
        handleClose={() => setApplicationsModalOpen(false)}
        userId={userData._id}
      />
      <CreateNewOcurrencesModal
        open={ocurrencesModalOpen}
        professional={userData}
        onClose={() => setOcurrencesModalOpen(false)}
      />
      <ApplyProfessionalModal
        open={newApplicationModalOpen}
        user={userData}
        onClose={() => setNewApplicationModalOpen(false)}
      />
      <ProfessionalAllDocsModal
        open={allDocsModalOpen}
        onClose={() => setAllDocsModalOpen(false)}
        professional={userData}
      />
      {/* <TermsModal open={termsModalOpen} onClose={handleCloseTermsModal} /> */}
    </Content>
  );
};

export default Perfil;
